// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac42ce1c","453":"c1fc13ab","455":"e7bb41ea","977":"2d2de37d"}[chunkId] + ".chunk.js";
};